import { defineComponent } from 'vue';
import { LoanDetailsData } from '@/interfaces/loan';

export default defineComponent({
  name: 'LoanDataMixin',

  data() {
    return {
      loadingLoanData: false,
    };
  },

  computed: {
    hasLoanData(): boolean {
      return this.$store.getters['Loan/hasLoanData'];
    },

    loanData(): LoanDetailsData {
      return this.$store.getters['Loan/getLoanData'];
    },
  },
});
